export const selectGalleryData = ({galleryData}) => galleryData;
export const selectGalleryDataBreadcrumbs = (state) => selectGalleryData(state)?.breadcrumbs;
export const selectGalleryDataPageDisplayName = (state) =>
  selectGalleryData(state)?.pageDisplayName;
